module.exports = __webpack_public_path__ + "img/maTouQin2.13758367.png";